// components/RightSwiper.jsx
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import SwiperBack from '../../assets/swiper-back.png'
import './index.css'
const RightSwiper = () => {
  const slides = [
    { img: require('../../assets/focus-1.png') },
    { img: require('../../assets/focus-2.png') },
    { img: require('../../assets/focus-3.png') },

  ];

  return (
    <div className="flex-swiper">
      {/* 固定左侧文字区块 */}
      <img className='fixed-text-container' src={SwiperBack} />

      {/* 右侧轮播容器 */}
      <div className='swiper-box'>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop={true}
        autoplay={{ delay: 5000,
          disableOnInteraction: false  }}
        navigation={{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }}
        pagination={{
          el: '.custom-pagination',
          clickable: true,
          bulletClass: 'custom-bullet',
          bulletActiveClass: 'custom-bullet-active'
        }}
        className="right-swiper-container"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="image-wrapper">
              <img 
                src={slide.img} 
                alt={`Slide ${index + 1}`}
                className="right-aligned-image"
              />
            </div>
          </SwiperSlide>
        ))}
        {/* 自定义导航按钮 */}
      </Swiper>
      </div>
      <div className="custom-pagination"></div>
      <div className="custom-navigation">
        <img 
          className="custom-prev"
          src={require('../../assets/left-icon.png')} 
          alt="prev"
          role="button" // 添加语义化属性
        />
        <img
          className="custom-next"
          src={require('../../assets/right-icon.png')}
          alt="next"
          role="button"
        />
      </div>
    </div>
  );
};

export default RightSwiper;